import { ChipNavigationMui } from '@mi-front/ui';
import { Box } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { VIDEO_EDITIONS_EDIT_GROUP_QUERY_PARAM } from '../../lib/video-editions-edit-group-query-param';

const draftChipMessage = defineMessage({
  id: 'videoEditions.category.draftChip',
  defaultMessage: 'Borradores y en progreso ({count})',
});

const generatedChipMessage = defineMessage({
  id: 'videoEditions.category.generatedChip',
  defaultMessage: 'Generados ({count})',
});

export interface VideoEditionsCategoryChipsProps {
  /** Shown after the chips in the toolbar (e.g. create edit). */
  header?: React.ReactNode;
  draftCount: number;
  generatedCount: number;
  draftContent: React.ReactNode;
  generatedContent: React.ReactNode;
}

/**
 * URL-driven chip navigation for draft vs generated video edition edits, built on ChipNavigationMui.
 */
export function VideoEditionsCategoryChips({
  header,
  draftCount,
  generatedCount,
  draftContent,
  generatedContent,
}: VideoEditionsCategoryChipsProps) {
  return (
    <ChipNavigationMui
      param={VIDEO_EDITIONS_EDIT_GROUP_QUERY_PARAM}
      defaultActiveChip="draft"
      header={header}
      headerPosition="inline"
      chips={[
        {
          value: 'draft',
          label: <FormattedMessage {...draftChipMessage} values={{ count: draftCount }} />,
          content: <Box sx={{ mt: 2 }}>{draftContent}</Box>,
          disabled: draftCount < 1,
        },
        {
          value: 'generated',
          label: <FormattedMessage {...generatedChipMessage} values={{ count: generatedCount }} />,
          content: <Box sx={{ mt: 2 }}>{generatedContent}</Box>,
          disabled: generatedCount < 1,
        },
      ]}
      sx={{ mb: 2 }}
    />
  );
}
